module.exports = __webpack_public_path__ + "img/panews.cb60ab05.png";